<template>
  <NodeViewWrapper
      as="figure"
      class="editor-figure"
      :style="figureStyle"
      @click="onFigureClick"
  >
    <!-- Кнопки управления -->
    <div class="image-controls" contenteditable="false">
      <button @click.stop="addTopSpace" title="Отступ сверху">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 5v14" />
          <path d="M16 9l-4 -4" />
          <path d="M8 9l4 -4" />
        </svg>
      </button>

      <button @click.stop="addBottomSpace" title="Отступ снизу">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 5v14" />
          <path d="M16 15l-4 4" />
          <path d="M8 15l4 4" />
        </svg>
      </button>

      <button @click.stop="remove" title="Удалить">✕</button>
    </div>

    <NodeViewContent />
  </NodeViewWrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent } from '@tiptap/vue-3'
import { TextSelection } from 'prosemirror-state'

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent,
  },

  computed: {
    figureStyle() {
      return {
        marginTop: `${this.node.attrs.marginTop || 0}px`,
        marginBottom: `${this.node.attrs.marginBottom || 0}px`,
      }
    },
  },

  methods: {
    onFigureClick(event) {
      // ❌ клики по кнопкам
      if (event.target.closest('.image-controls')) return

      // ❌ если уже кликаем в figcaption — не мешаем редактированию
      if (event.target.closest('figcaption')) return

      // ✅ реагируем ТОЛЬКО на клик по картинке
      if (event.target.tagName !== 'IMG') return

      const { editor, getPos, node } = this

      // imageFigure → image (0) + figcaption (1)
      if (node.childCount < 2) return

      const figcaptionPos =
          getPos() +
          1 +
          node.child(0).nodeSize

      editor.view.dispatch(
          editor.state.tr.setSelection(
              TextSelection.create(editor.state.doc, figcaptionPos + 1)
          )
      )

      editor.commands.focus()
    },

    addTopSpace() {
      const { editor, getPos, node } = this
      const pos = getPos()

      editor
          .chain()
          .focus()
          .command(({ tr }) => {
            tr.setNodeMarkup(pos, undefined, {
              ...node.attrs,
              marginTop: (node.attrs.marginTop || 0) + 16,
            })
            return true
          })
          .insertContentAt(pos, {
            type: 'paragraph',
          })
          .run()
    },

    addBottomSpace() {
      const { editor, getPos, node } = this
      const pos = getPos() + node.nodeSize

      editor
          .chain()
          .focus()
          .command(({ tr }) => {
            tr.setNodeMarkup(getPos(), undefined, {
              ...node.attrs,
              marginBottom: (node.attrs.marginBottom || 0) + 16,
            })
            return true
          })
          .insertContentAt(pos, {
            type: 'paragraph',
          })
          .run()
    },

    remove() {
      const { editor, getPos, node } = this

      editor
          .chain()
          .focus()
          .deleteRange({
            from: getPos(),
            to: getPos() + node.nodeSize,
          })
          .run()
    },
  },
}
</script>

<style scoped>
.editor-figure {
  position: relative;
  display: inline-block;
}

.image-controls {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;

  display: flex;
  gap: 6px;
}

.image-controls button {
  width: 28px;
  height: 28px;

  background: rgba(0, 0, 0, 0.6);
  color: #fff;

  border: none;
  border-radius: 50%;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
}

.image-controls button:hover {
  background: rgba(0, 0, 0, 0.85);
}
</style>
